// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"397cd065","498":"8aa0420e","703":"0b89526b","787":"6c2dc351"}[chunkId] + ".chunk.js";
};